import {
  defineNuxtRouteMiddleware,
  navigateTo,
  useAppConfig,
  useRequestEvent,
  useRouter,
} from '#imports'

type HankoRedirects = {
  login: string
  success: string
  home: string
  followRedirect?: boolean
}

type HankoAppConfig = {
  hanko: {
    redirects: HankoRedirects
  }
}

export default defineNuxtRouteMiddleware(async to => {
  const redirects = (useAppConfig() as HankoAppConfig).hanko.redirects

  if (process.server) {
    const event = useRequestEvent()!

    if (event.context.hanko?.sub && to.path !== redirects.home) {
      return navigateTo(redirects.home)
    }
    return
  }

  const hanko = await useHankoClient()
  const session = await hanko.validateSession().catch(() => null)

  if (session?.is_valid && to.path !== redirects.home) {
    return navigateTo(redirects.home)
  }

  const removeHankoHook = hanko.onSessionCreated(() => {
    if (!redirects.followRedirect || !to.query.redirect) {
      navigateTo(redirects.success)
      return
    }
    navigateTo(to.query.redirect.toString())
  })
  const removeRouterHook = useRouter().beforeEach(() => {
    removeHankoHook()
    removeRouterHook()
  })
})
